/**
 * OrbDocCoreConceptsPagesENDocEx1LibraryPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPagesENDocEx1LibraryPage
 */

import { useOrbDocCoreConceptsPagesENDocEx1LibraryPageLogic } from '@/hooks/traits/useOrbDocCoreConceptsPagesENDocEx1LibraryPageLogic';
import type { OrbDocCoreConceptsPagesENDocEx1LibraryPageConfig } from '@/hooks/traits/useOrbDocCoreConceptsPagesENDocEx1LibraryPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPagesENLibraryView as OrbDocCoreConceptsPagesENLibraryViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPagesENBookFactsView } from '@/components/traits/OrbDocCoreConceptsPagesENBookFactsView';
import { OrbDocCoreConceptsPagesENBookShelfView } from '@/components/traits/OrbDocCoreConceptsPagesENBookShelfView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPagesENDocEx1LibraryPageViewProps {
  config?: Partial<OrbDocCoreConceptsPagesENDocEx1LibraryPageConfig>;
}

export function OrbDocCoreConceptsPagesENDocEx1LibraryPageView({ config: propsConfig }: OrbDocCoreConceptsPagesENDocEx1LibraryPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPagesENDocEx1LibraryPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPagesENLibraryView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPagesEN" trait="OrbDocCoreConceptsPagesENDocEx1LibraryPage">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="lg"><OrbDocCoreConceptsPagesENBookFactsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPagesENBookShelfView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPagesENDocEx1LibraryPageView;
